<template>
  <span :style="style">
    <el-select
      v-if="editable && !useVuetify"
      v-model="selectedId"
      @change="do_change"
      :placeholder="placeholder"
      :size="size"
      :multiple="multi"
      :filterable="true"
      :clearable="clearable"
    >
      <el-option
        v-if="allowAll && !multi"
        :value="0"
        :label="'Any Type'"
      ></el-option>
      <el-option
        v-for="option in leadTypes"
        :value="option.id"
        :key="option.id"
        :label="option.name"
      >
      </el-option>
    </el-select>
    <v-select
      v-if="editable && useVuetify"
      v-model="selectedId"
      @update:model-value="do_change"
      :label="placeholder"
      :placeholder="placeholder"
      :items="selectOptions"
      :multiple="multi"
      :density="vuetifyDensity"
      :clearable="clearable"
      hide-details="auto"
      variant="outlined"
    ></v-select>
    <span v-if="!editable">
      {{ getSelectedName() }}
    </span>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'leadTypeSelect',
  computed: {
    ...mapGetters('leadType', ['getLeadTypes']),
    leadTypes() {
      return this.leadCategory
        ? this.getLeadTypes.filter(
            (lt) => lt.lead_category_id == this.leadCategory
          )
        : this.getLeadTypes;
    },
    selectOptions() {
      const options = this.leadTypes.map((type) => ({
        value: type.id,
        title: type.name,
      }));

      if (this.allowAll && !this.multi) {
        options.unshift({ value: 0, title: 'Any Type' });
      }

      return options;
    },
    vuetifyDensity() {
      const densityMap = {
        default: 'default',
        small: 'compact',
        mini: 'comfortable',
      };
      return densityMap[this.size] || 'compact';
    },
  },
  props: {
    value: {
      type: Number,
    },
    initialId: {
      // An array of ids when multi is set
      type: [Number, Array],
      required: false,
    },
    leadCategory: {
      type: Number,
      required: false,
    },
    size: {
      type: String,
      default: () => {
        return 'small';
      },
    },
    placeholder: {
      type: String,
      required: false,
      default: () => {
        return 'Select a Lead Type';
      },
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
    allowAll: {
      type: Boolean,
      required: false,
      default: false,
    },
    multi: {
      type: Boolean,
      required: false,
      default: false,
    },
    style: { type: Object },
    // Allow selecting no lead type
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    useVuetify: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      selectedId: undefined,
    };
  },
  watch: {
    initialId(id) {
      this.selectedId = this.normalizeSelection(id);
    },
    value(n) {
      this.selectedId = parseInt(n);
    },
  },
  async created() {
    this.selectedId = this.normalizeSelection(this.initialId);
  },
  methods: {
    // Multi selects always need an array to bind against
    normalizeSelection(id) {
      if (!this.multi) {
        return id;
      }
      if (Array.isArray(id)) {
        return id;
      }
      return id == undefined ? [] : [id];
    },
    do_change() {
      this.$emit(
        'update:leadType',
        this.getLeadTypes.find((s) => s.id == this.selectedId)
      );
      this.$emit('update:modelValue', this.selectedId);
      this.$emit('change', this.selectedId);
    },
    getSelectedName() {
      const lt = this.getLeadTypes.find((s) => s.id == this.selectedId);
      return lt ? lt.name : 'Unknown';
    },
  },
};
</script>
